import { setSelectedProfile } from "../actions/CommonActions";
import { SimpleCatchError } from "../utils/Helper";
import { Axios } from "../utils/axiosMiddleware";

/**
 * Loads the full profile (incl. `subscribed`, which the subscription screen
 * uses to decide manage-vs-subscribe) and stores it as the selected profile.
 *
 * `token` is the mobile WebView deep-link JWT (`?token=`). The shared `Axios`
 * interceptor only reads the auth blob from `localStorage`, which is empty
 * inside the WebView, so without this the `GetFullUser` request goes out
 * unauthenticated → 401 → the profile never loads → `subscribed` is
 * undefined → the subscription screen shows "Subscribe" to an already-subscribed
 * user and would run the checkout (new sub) path instead of the manage/portal
 * path. When a token is passed we set `Authorization` explicitly; desktop web
 * (and the other callers) pass no token and use the interceptor's localStorage
 * token, so those paths are unchanged.
 */
export const getProfile = async (dispatch, user_id, id, user_type, token) => {
  try {
    const response = await Axios.get(
      `user/GetFullUser/${user_id}/${id}/${user_type}`,
      token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
    );
    dispatch(setSelectedProfile(response?.data[0]));
  } catch (e) {
    SimpleCatchError(e);
  }
};
